export const ALL = 'ALL';
export const ASSIGNED_TO_USER = 'ASSIGNED_TO_USER';
export const ASSIGNED_TO_USERS_TEAM = 'ASSIGNED_TO_USERS_TEAM';
export const USER = 'USER';
export const TEAM = 'TEAM';
export const DEFAULT = 'DEFAULT';
export const CREATED_BY_ME = 'createdByMe';
export const CREATED_BY_MY_TEAM = 'createdByMyTeam';
export const OWNED_BY_ME = 'ownedByMe';
export const OWNED_BY_MY_TEAM = 'ownedByMyTeam';